import { Button, Flex } from '@chakra-ui/react';

type TProps = {
    disabled: boolean;
    loading: boolean;
    onCancel: () => void;
    onSave: () => void;
};

const UpdateCancel = ({ disabled, loading, onCancel, onSave }: TProps) => (
    <Flex gap="8px" justifyContent="flex-end">
        <Button height="48px" padding="0 24px" variant="outline" isDisabled={disabled || loading} onClick={onCancel}>
            Cancel
        </Button>
        <Button
            height="48px"
            padding="0 24px"
            variant="brand"
            isDisabled={disabled}
            onClick={onSave}
            isLoading={loading}
        >
            Update & Save
        </Button>
    </Flex>
);

export default UpdateCancel;
